import { TConfigInput, TConfigParams } from '@@/auto/interfaces';

function ToyotaTXConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled('isToggleTXExpansionEnabled')
    ? {
        coverage: {
          uninsuredMotoristPropertyDamage: {
            description: `Your bumper sticker might say 'don't hit me if you're uninsured or underinsured' but it isn't actually protecting you against that. Don't worry, this coverage can.`,
            modalContent: `Uninsured Motorist Property Damage (UMPD) pays, up to the limits chosen, the amount you are legally entitled to recover for physical damages to your insured car sustained in an accident caused by a driver who is not insured or doesn't have enough insurance to cover the damage. Note: Payments for this coverage are subject to a $250 deductible.`,
          },
        },
      }
    : {};
}

export default ToyotaTXConfig;
